<template>
  <v-app>
    <navibar />
    <v-main class="main">
      <router-view />
    </v-main>
  </v-app>
</template>
<script>
import navibar from "@/components/Nav/NaviBar";

export default {
  name: "App",
  components: {
    navibar,
  },

  data: () => ({
    //
  }),
  created() {
    //document.getElementsByClassName('progressLoading')[0].remove();
  },
};
</script>
<style>
#app {
  font-family: Roboto, Calibri, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  font-size: 16px;
}
.main {
  background: url("~@/assets/bg1.jpg") no-repeat center;
  background-size: cover;
 
}
.btn-modal {
  width: 80px;
}
@media only screen and (max-width: 599px) {
  .my-data-table > div > table > tbody {
    display: block !important;
  }
}
</style>
